import { render, staticRenderFns } from "./anonssub.vue?vue&type=template&id=97ea8b8c&"
import script from "./anonssub.vue?vue&type=script&lang=js&"
export * from "./anonssub.vue?vue&type=script&lang=js&"
import style0 from "./anonssub.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports